import brandie from './brandie'
import config from '../config'

export const themes = {
  brandie
}
export function getThemes () {
  return config.themes.map((key) => ({ key, config: themes[key] }))
}
